/** 与 userLogin 一致的委外打印 modules 编码 */
export const OUTSOURCING_PRINT_MODULES = {
  PRODUCT_ORDER: 47,
  PRODUCT_MATERIALS: 48,
  PRODUCT_RETURN: 49,
  PRODUCT_FINISH: 50,
  PROCESS_ORDER: 127,
  PROCESS_MATERIALS: 170,
  PROCESS_RETURN: 171,
  PROCESS_RECEIVE: 172,
  PROCESS_COOP_DELIVERY: 172,
  STATEMENT: 84,
  WAREHOUSE: 195,
};

/** 按单据主键去重，避免合并行重复打印 */
export function dedupePrintList(list, idField) {
  const map = new Map();
  (list || []).forEach((item) => {
    const id = item && item[idField];
    if (id !== null && id !== undefined && id !== '') {
      map.set(String(id), item);
    }
  });
  return [...map.values()];
}

export function buildPrintChangeList(list, idField) {
  return dedupePrintList(list, idField);
}
